import React, { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Spinner from '../layout/Spinner';
import PostItem from '../posts/PostItem';
import PostForm from '../posts/PostForm';
import { getUsersPosts } from '../../actions/post';

const ProfilePosts = ({
  getUsersPosts,
  post: { posts, loading },
  auth,
  userId
}) => {
  useEffect(() => {
    getUsersPosts(userId);
  }, [getUsersPosts]);

  return loading ? (
    <Spinner />
  ) : (
    <Fragment>
      {/* <PostForm /> */}

      <div className="posts">
        {posts.length > 0 ? (
          posts.map((post) => <PostItem key={post._id} post={post} />)
        ) : (
          <div className="card rounded-0 mb-3 shadow-sm">
            <div className="card-body my-4">
              <h5 className="my-0 text-center">
                <i className="fas fa-heart-broken heartbreak"></i> User
                currently has no posts
              </h5>
            </div>
          </div>
        )}
        {/*     {posts.map((post) => (
          <PostItem key={post._id} post={post} />
        ))} */}
      </div>
    </Fragment>
  );
};

ProfilePosts.propTypes = {
  getUsersPosts: PropTypes.func.isRequired,
  post: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
  post: state.post,
  auth: state.auth
});

export default connect(mapStateToProps, { getUsersPosts })(ProfilePosts);
